import { z } from 'zod';

export const requestSchema = z.object({
  email: z.string().email(),
});

export type RequestInput = z.infer<typeof requestSchema>;

export const confirmSchema = z
  .object({
    new_password: z.string().min(1),
    confirm_password: z.string().min(1),
  })
  .refine((d) => d.new_password === d.confirm_password, {
    path: ['confirm_password'],
    message: 'passwords_must_match',
  });

export type ConfirmInput = z.infer<typeof confirmSchema>;
